import { defineStore } from 'pinia'
import { defineComponent, ref, type SetupContext } from 'vue'

export const useGetAnOfferStore = defineStore('getAnOfferStore', () => {
  const action = ref<() => void>(() => undefined)

  return {
    action,
  }
})

export default defineComponent({
  name: 'equipment-get-an-offer-cta',
  setup(props, { slots }: SetupContext) {
    const getAnOfferStore = useGetAnOfferStore()

    function action() {
      getAnOfferStore.action()
    }

    return () =>
      slots.default?.({
        action,
      })
  },
})
